import { Icon } from '@iconify/react'
import { WinnersSectionCard } from '@/components/WinnersSectionCard'
import { RoletaDistributedPrizesTable } from '@/pages/CampanhasPage/RoletaDistributedPrizesTable'
import sectionStyles from './WinnersPageSections.module.css'

export interface RoletaWinnersSectionProps {
  campaignId: number | null
  isLoading: boolean
  hasCampaigns: boolean
  token: string | null
  canUpdateStatus: boolean
}

export function RoletaWinnersSection({
  campaignId,
  isLoading,
  hasCampaigns,
  token,
  canUpdateStatus,
}: RoletaWinnersSectionProps) {
  return (
    <WinnersSectionCard
      id="winners-roleta-section"
      title="Ganhadores da roleta"
      subtitle="Prêmios distribuídos na roleta da campanha de sorteio selecionada."
      icon="mdi:ferris-wheel"
    >
      {isLoading ? (
        <div className={sectionStyles.centered}>
          <Icon icon="mdi:loading" className={sectionStyles.spinner} />
          Carregando campanha de sorteio...
        </div>
      ) : !hasCampaigns ? (
        <p className={sectionStyles.emptyMessage}>
          Nenhuma campanha de sorteio cadastrada. Os prêmios da roleta dependem dessa campanha.
        </p>
      ) : campaignId == null ? (
        <p className={sectionStyles.emptyMessage}>
          Selecione uma campanha de sorteio no topo da página.
        </p>
      ) : (
        <RoletaDistributedPrizesTable
          key={campaignId}
          campaignId={campaignId}
          token={token}
          canUpdateStatus={canUpdateStatus}
          embedded
        />
      )}
    </WinnersSectionCard>
  )
}
